/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPageHero from 'flarum/newvigation/components/IndexPageHero';
import CreateReviewPrimaryButton from '../components/CreateReviewPrimaryButton';
import { followTagsComponents } from '../../common/utils/followTagsApi';

export default function () {
	extend(IndexPageHero.prototype, 'items', function (items) {
		const { currentTag, type } = this.attrs;

		let SubscriptionMenu;
		if (app.initializers.has('fof/follow-tags') && currentTag && app.session.user) {
			SubscriptionMenu = followTagsComponents.SubscriptionMenu;
		}

		if (type === 'reviews') {
			items.add(
				'controls',
				<div className="IndexPageHero-controls">
					<CreateReviewPrimaryButton />
					{SubscriptionMenu && <SubscriptionMenu model={currentTag} />}
				</div>
			);
		}
	});
}
